import { SELECTEDTAB_INDEX } from 'state/selectedTab/constants';
import { getTabs } from 'state/tabs';

export function getIsLoading(state, tabIndex) {
  let index = tabIndex !== undefined ? tabIndex : SELECTEDTAB_INDEX;

  return getTabs(state)[index].isLoading;
}
